import styled from 'styled-components'

const Wrap = styled.div`
  position: sticky;
  top: 4rem;
  bottom: 0;
`

export { Wrap }
